import { DocumentMode } from './document-mode';
import { getDocumentMode } from './getDocumentMode';

export const getCurrentDocumentApiUrl = (pathname: string, documentMode?: DocumentMode, entityId?: string): string => {
  const {
    mode,
    ids: [$1, $2],
  } = getDocumentMode(pathname);

  const parsedDocumentMode = documentMode ?? mode;
  const isTemplate = parsedDocumentMode === DocumentMode.TEMPLATES;
  const isEndorsement = parsedDocumentMode === DocumentMode.ENDORSEMENTS;
  const isSubmission = parsedDocumentMode === DocumentMode.SUBMISSIONS;

  const variant = isTemplate ? 'templates' : isSubmission || isEndorsement ? 'submissions' : undefined;

  if (!variant) {
    throw new Error('Unable to access resource. Please try again.');
  }

  const url = [variant, entityId ?? $1, isEndorsement && $2 && `endorsements`, isEndorsement && $2]
    .filter(Boolean)
    .join('/');

  return url;
};
